import { gql } from "apollo-boost";

const UPDATE_ADVANCE_PRODUCT_APPROVAL_SETTING = gql`
  mutation updateAdvanceProductApprovalSetting($input: UpdateAdvanceProductApprovalInput) {
    updateAdvanceProductApprovalSetting(input: $input) {
      status
      error
      data
    }
  }
`;

export default UPDATE_ADVANCE_PRODUCT_APPROVAL_SETTING;
